var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup85({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2524 22.2347L14.5332 19.5381C13.2835 18.2988 12.6586 17.6791 11.9391 17.4467C11.3062 17.2421 10.6251 17.2421 9.9921 17.4467C9.27268 17.6791 8.64777 18.2988 7.39796 19.5381L1.06639 25.9151M17.2524 22.2347L17.7928 21.6986C19.069 20.4332 19.7069 19.8005 20.4391 19.5696C21.0828 19.3665 21.7746 19.3744 22.4136 19.5923C23.1401 19.8401 23.7634 20.4872 25.01 21.7815L26.3333 23.1252M17.2524 22.2347L23.515 28.6078M1.06639 25.9151C1.11501 26.3274 1.19923 26.6512 1.34515 26.9377C1.64874 27.5335 2.13319 28.018 2.72903 28.3215C3.40641 28.6667 4.29316 28.6667 6.06667 28.6667H21.2667C22.2504 28.6667 22.9613 28.6667 23.515 28.6078M1.06639 25.9151C1 25.3521 1 24.6238 1 23.6V8.4C1 6.62651 1 5.73975 1.34515 5.06236C1.64874 4.46651 2.13319 3.98207 2.72903 3.67848C3.40641 3.33333 4.29316 3.33333 6.06667 3.33333H12.0833M23.515 28.6078C23.9594 28.5604 24.3027 28.4752 24.6043 28.3215C25.2001 28.018 25.6846 27.5335 25.9882 26.9377C26.3333 26.2603 26.3333 25.3735 26.3333 23.6V17.5833M23.1667 11.25V6.5M23.1667 6.5V1.75M23.1667 6.5H27.9167M23.1667 6.5H18.4167",
    stroke: "#FF7A00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup85);
export default __webpack_public_path__ + "static/media/Group 85.eb7869d1c3e89fc038249435bdfeaa16.svg";
export { ForwardRef as ReactComponent };